import { render, staticRenderFns } from "./WagePeriodCreateModal.vue?vue&type=template&id=ab378804&"
import script from "./WagePeriodCreateModal.vue?vue&type=script&lang=js&"
export * from "./WagePeriodCreateModal.vue?vue&type=script&lang=js&"
import style0 from "./WagePeriodCreateModal.vue?vue&type=style&index=0&id=ab378804&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports